module.exports = __webpack_public_path__ + "img/cross-icon.43996281.svg";